import PacsStore from './pacs/state/PacsStore';
import ConfigStore from './config/state/ConfigStore';
import ClienteStore from './clientes/state/ClienteStore';
import DashboardInfoStore from './dashboard/state/DashboardInfoStore';
import DashboardListStore from './dashboard/state/DashboardListStore';
import ReporteClienteInfoStore from './reportes/clientes/state/ReporteClienteInfoStore';
import ReporteClienteListStore from './reportes/clientes/state/ReporteClienteListStore';
import AdminReportesPacsBalanceListStore from './reportes/pacs/state/AdminReportesPacsBalanceListStore';
import ReporteFacturacionClienteListStore from './reportes/facturacion/state/ReporteFacturacionClienteListStore';
import ReporteFacturacionHitsPorPacListStore from './reportes/facturacion/state/ReporteFacturacionHitsPorPacListStore';
import ReporteFacturacionXmlStampingStoragetore from './reportes/facturacion/state/ReporteFacturacionXmlStampingStoragetore';

const AdminStore = {
  clientes: ClienteStore,
  dashboard: {
    list: DashboardListStore,
    info: DashboardInfoStore,
  },
  pacs: PacsStore,
  config: ConfigStore,
  reportes: {
    pacs: {
      balance: AdminReportesPacsBalanceListStore,
    },
    facturacion: {
      hits_clientes: ReporteFacturacionClienteListStore,
      hits_pacs: ReporteFacturacionHitsPorPacListStore,
      xml_storage: ReporteFacturacionXmlStampingStoragetore,
    },
    clientes: {
      info: ReporteClienteInfoStore,
      list: ReporteClienteListStore,
    },
  },
};

export default AdminStore;
